module.exports = __webpack_public_path__ + "media/images/site/rectangle-9c777b97f89a5c732bc04a3b34ee17d0.svg";